<template>
    <van-popup
        :value.sync="selectCompanyListVisible"
        round
        position="bottom"
        :style="{ height: '408px' }"
        @click-overlay="handleClosePopup"
        v-if="selectCompanyListVisible"
    >
        <div class="select_company_box" v-if="selectCompanyListVisible">
            <div class="select_company_box_title">
                <span>已选客户（{{ selectCompanyData.length }}）</span>
                <span class="clear_text" @click="handleClickClearAll">清空</span>
            </div>
            <ul>
                <li v-for="(item,index) in selectCompanyData" :key="item.id">
                    <span class="title ellipsis">{{ item.name && item.name.value }}</span>
                    <van-icon name="cross" @click="handleClickDelete(item, index)" />
                </li>
            </ul>
        </div>
    </van-popup>
</template>
<script>
export default {
    name: "SelectCompanyList",
    props: {
        selectCompanyListVisible: {
            type: Boolean,
            default: false,
        },
        selectCompanyData: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {};
    },
    methods: {
        handleClosePopup() {
            this.$emit("update:selectCompanyListVisible", false);
        },
        handleClickDelete(item) {
            this.$emit("changeItemSelete", {type: "item", data: item})
        },
        handleClickClearAll() {
            this.$emit("update:selectCompanyData", [])
            this.$emit("changeItemSelete", {type: "all"})
        }
    },
};
</script>
<style lang="scss">
.van-popup {
    .select_company_box {
        height: 358px;
        background: rgba(247, 248, 250, 1);
        .select_company_box_title {
            position: relative;
            height: 48px;
            text-align: center;
            line-height: 48px;
            span:nth-child(1) {
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(51, 51, 51, 1);
            }
            .clear_text {
                position: absolute;
                top: 13px;
                right: 16px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(228, 65, 68, 1);
            }
        }
        ul {
            height: 310px;
            overflow-y: scroll;
            padding: 0 16px;
            li {
                padding: 0 10px;
                height: 44px;
                border-radius: 8px;
                background: rgba(255, 255, 255, 1);
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .title {
                    flex: 1;
                }
                .van-icon-cross {
                    font-size: 24px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
}
</style>
